import * as React from 'react';
import {Divider, Box, Typography, Link, Grid} from '@mui/material'
import { Trans, withTranslation, useTranslation  } from 'react-i18next';

interface apply_stat {
    apply_stat: string
  }

function WorkAtHomeContent ({ apply_stat }: apply_stat) {
    const { t } = useTranslation();
    return ( 
        <Box>
            <Typography sx={{ pt: 5, display: 'flex', justifyContent: 'left',fontWeight: 400}} variant='subtitle1' >
                {t("workathome.header")}
            </Typography>
            { apply_stat === "yes" ? 
                <Box>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2}}>
                    {t("workathome.licenseinfo")}
                    </Typography>
                    <Typography variant='subtitle1' component="ul">
                        <Trans i18nKey="workathome.expire" components={[<li></li>]}></Trans>
                    </Typography>
                    <Typography variant='subtitle1'  sx={{ fontWeight: 600, mt: 2}}>
                        {t("workathome.software")}
                    </Typography>
                    <Typography variant='subtitle1'  component="ul" sx={{ fontWeight: 400, mt: 1}}>
                        <li>{t("workathome.software_c0")}</li>
                        <Typography variant='subtitle1' sx={{ fontWeight: 400, mt: 2}}>
                            {t("workathome.software_c")}
                            <Typography variant='subtitle1' component="ul" sx={{ fontWeight: 400, mt: 1, mb:2}}>
                                <li>{t("workathome.software_c1")}</li>
                                <li>{t("workathome.software_c2")}</li>
                            </Typography>
                        {t("workathome.software_c3")}
                        </Typography>
                    </Typography>
                    <Typography variant='subtitle1' sx={{ mt:3, mb: 2}} >
                        {t("workathome.body1")}
                    </Typography>
                    <Grid container sx={{ height: 100 }}>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, borderTop: 1, pl: 1, py:1 }}>{t("workathome.engver")}</Grid>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, borderRight:1, borderTop: 1, pl: 1, py:1 }}><Link href="https://umdrive.um.edu.mo/link/AA25FE15D0583940A18F80C9E75D2CA60A" target="_blank" rel="noreferrer">64-bit</Link></Grid>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, pl: 1, py:1 }}>{t("workathome.tradver")}</Grid>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, borderRight:1, pl: 1, py:1 }}><Link href="https://umdrive.um.edu.mo/link/AACACBDE56700546599186194546EB702C" target="_blank" rel="noreferrer">64-bit</Link></Grid>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, pl: 1, pt:1 }}>{t("workathome.simver")}</Grid>
                        <Grid item xs={6} sx={{borderLeft:1, borderBottom: 1, borderRight:1, pl: 1, py:1 }}><Link href="https://umdrive.um.edu.mo/link/AA6324A287D9CE49C18B840B4CA785A42C" target="_blank" rel="noreferrer">64-bit</Link></Grid>
                    </Grid>
                    <Typography variant='subtitle1' sx={{fontWeight: 600, mt: 3}}>{t("workathome.activateguide")}</Typography>
                    <Typography variant='subtitle1'>
                        <Trans i18nKey="workathome.refer">
                            <Link href="https://faq.icto.um.edu.mo/how-to-activate-windows-7-and-8-work-at-home/" target="_blank" rel="noreferrer" />
                        </Trans>
                    </Typography>
                    <Divider sx={{mt: 3, mb:2}}></Divider>
                    <Typography>
                        <Trans i18nKey="workathome.moreinfo">
                            <Link href="https://faq.icto.um.edu.mo/tag/work-at-home/" target="_blank" rel="noreferrer" />
                        </Trans>
                    </Typography>
                    
                </Box>: null
            }

            {   apply_stat === "no" ?
                <Box>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2}}>
                       {t("workathome.form")}
                    </Typography>
                    <Typography variant='subtitle1'  sx={{ fontWeight: 400, mt: 2}}>
                        <Trans i18nKey="workathome.form_c" components={{ s: <strong />, n: <br />}}> </Trans>
                    </Typography>
                    <Typography variant='subtitle1'  sx={{ fontWeight: 600, mt: 2}}>
                        {t("workathome.software")}
                    </Typography>
                    <Typography variant='subtitle1'  component="ul" sx={{ fontWeight: 400, mt: 1}}>
                        <li>{t("workathome.software_c0")}</li>
                        <Typography variant='subtitle1' sx={{ fontWeight: 400, mt: 2}}>
                            {t("workathome.software_c")}
                            <Typography variant='subtitle1' component="ul" sx={{ fontWeight: 400, mt: 1, mb:2}}>
                                <li>{t("workathome.software_c1")}</li>
                                <li>{t("workathome.software_c2")}</li>
                            </Typography>
                        {t("workathome.software_c3")}
                        </Typography>
                    </Typography>
                    <Typography variant='subtitle1' sx={{ fontWeight: 600, mt: 2}}>
                        {t("common.statement")}
                    </Typography>
                    <Typography variant='subtitle1' component='ul' sx={{ fontWeight: 400 }} >
                        <Trans i18nKey="workathome.statement" components={{ dot: <li />, link1: <Link href="https://support.microsoft.com/en-us/windows/windows-11-system-requirements-86c11283-ea52-4782-9efd-7674389a7ba3" target="_blank" rel="noreferrer" />}}> 
                        </Trans>    
                    </Typography>
                </Box>: null
            }
        </Box>
    );
};
export default withTranslation()(WorkAtHomeContent);